exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide {\n  display: none !important;\n}\ndiv[col-id='checked'] {\n  pointer-events: all !important;\n}\n.asignacionSeriado .estilo-grilla,\n.asignacionSeriado #gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.asignacionSeriado .ag-pinned-left-cols-container,\n.asignacionSeriado .ag-header .ag-pinned-left-header,\n.asignacionSeriado .ag-body-horizontal-scroll .ag-horizontal-left-spacer {\n  display: none;\n}\n", ""]);

// exports
